"use strict";
var ɵngcc0 = require('@angular/core');

var _c0 = ["*"];
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = require("@angular/core");
var AccordionHeading = (function () {
    function AccordionHeading() {
    }
AccordionHeading.ɵfac = function AccordionHeading_Factory(t) { return new (t || AccordionHeading)(); };
AccordionHeading.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AccordionHeading, selectors: [["accordion-heading"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function AccordionHeading_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccordionHeading, [{
        type: core_1.Component,
        args: [{
                selector: "accordion-heading",
                template: "<ng-content></ng-content>"
            }]
    }], function () { return []; }, null); })();
    return AccordionHeading;
}());
exports.AccordionHeading = AccordionHeading;

//# sourceMappingURL=AccordionHeading.js.map